import types from '../actionTypes';

export const listenLastImport = () => ({
    type: types.LISTEN_LAST_IMPORT,
});

export const unlistenLastImport = () => ({
    type: types.UNLISTEN_LAST_IMPORT,
});

export const listenLogs = importId => ({
    type: types.LISTEN_LOGS,
    meta: {
        importId,
    },
});

export const unlistenLogs = importId => ({
    type: types.UNLISTEN_LOGS,
    meta: {
        importId,
    },
});
